import React, { useEffect, useState } from 'react'
import { Checkbox } from '@tecuity/granite-ui'
import { useSelector, shallowEqual } from 'react-redux'

const ServerSelect2Param = ({ name, paramIndex, value, onChange, paramOptions }) => {
  const { fields } = useSelector((state) => state.designer.wizard, shallowEqual)
  const [options, setOptions] = useState([{ value: null, key: -1, label: 'Loading' }])
  const [optionsFromWizard, setOptionsFromWizard] = useState(false)
  const [fieldOptions, setFieldOptions] = useState([])

  useEffect(() => {
    if (value) {
      setOptionsFromWizard(value.fromWizard ? true : false)
    } else if (value === undefined) {
      onChange(name, { value: -1, fromWizard: false })
    }
  }, [value])

  useEffect(() => {
    updateOptions(paramOptions)
    setFieldOptions(
      fields
        ? Object.keys(fields).map((fieldId) => {
            const label = fields[fieldId].label
            const name = fields[fieldId].name
            return {
              value: fieldId,
              label:
                label !== '' && label
                  ? label.length > 50
                    ? label.substring(0, 50) + '...'
                    : label
                  : name,
            }
          })
        : []
    )
  }, [])

  useEffect(() => {
    updateOptions(optionsFromWizard ? fieldOptions : paramOptions)
  }, [fieldOptions, paramOptions, optionsFromWizard])

  const updateOptions = (optionsIn) => {
    if (!optionsIn) {
      return
    }

    if (value && optionsIn.length > 0 && !optionsIn.find((x) => x.value == value.value)) {
      onChange(name, { value: optionsIn[0].value, fromWizard: optionsFromWizard })
    }
    setOptions(optionsIn)
  }

  const handleChange = (e) => {
    onChange(name, { value: e.target.value, fromWizard: optionsFromWizard })
  }

  return (
    <div>
      <select onChange={handleChange} value={value ? value.value : -1}>
        {!options || options.length < 0 ? (
          <option value={-1} key={'none'}>
            {' '}
            Cannot Find Options{' '}
          </option>
        ) : (
          options.map((option, i) => {
            return (
              <option value={option.value} key={i}>
                {option.label}
              </option>
            )
          })
        )}
      </select>

      {name != 'sourceCode' && (
        <div className={'dummy-field attribute '}>
          <div className="block-wrapper">
            <Checkbox
              label={`Override parameter #${paramIndex} with field from wizard`}
              checked={optionsFromWizard}
              onClick={(e) => setOptionsFromWizard(e.target.checked)}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default ServerSelect2Param
